<div class="rating">
  <div class="cnt-titolo-rating">
    <div *ngIf="titolo" class="cnt-titolo-info">
      <div class="titolo">{{ titolo }}</div>

      <button
        mat-icon-button
        (click)="apriInfo()"
        [matTooltip]="'Apri per visualizzare la tabella informativa'"
      >
        <mat-icon class="material-icons-outlined icone-label-chack"> help_outline</mat-icon>
      </button>
    </div>

    <star-rating
      [readOnly]="idSurveyCompilato ? true : false"
      (mouseleave)="onHoverRatingLeave()"
      [id]="idRating"
      [numOfStars]="numeroStelle"
      [hoverEnabled]="true"
      (starClickChange)="onClick($event)"
      (ratingChange)="onRatingChange($event)"
      (hoverRatingChange)="onHoverRatingChange($event)"
      [rating]="valoreAtribuito"
    >
    </star-rating>
  </div>

  <div *ngIf="mostraPunteggio" class="punteggio" [style.background-color]="colorePunteggio">
    {{ punteggio }}/{{ numeroStelle }}
  </div>
</div>
